export default __webpack_public_path__ + "static/media/imagebg.ceeba1fa.png";